export default {"src":"/_next/static/media/drill-execution.4b01b3f0.svg","height":576,"width":576,"blurWidth":0,"blurHeight":0};